import actions from '@/store/modules/accounting/booking-account/actions';
import mutations from '@/store/modules/accounting/booking-account/mutations';
import initialState from '@/store/modules/accounting/booking-account/state';

export default {
  namespaced: true,
  state: { ...initialState },
  mutations,
  actions,
};
